"use client";

import { useState } from "react";

import QuoteItemSelector from "@/components/quote-item-selector";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import type { AllQuoteItem } from "@/types";

interface QuoteItemMatchModalProps {
  requestItemId: number;
  requestItemDescription: string;
  supplierName: string;
  allSupplierQuoteItems: AllQuoteItem[];
  currentQuoteItemId?: number | null;
  onMatchUpdate?: () => void;
  children: React.ReactNode;
}

export default function QuoteItemMatchModal({
  requestItemId,
  requestItemDescription,
  supplierName,
  allSupplierQuoteItems,
  currentQuoteItemId,
  onMatchUpdate,
  children,
}: QuoteItemMatchModalProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleMatchUpdate = () => {
    setIsOpen(false);
    onMatchUpdate?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Asignar Producto del Proveedor</DialogTitle>
          <DialogDescription>
            Selecciona un producto cotizado por {supplierName} para asignar a
            este item de la solicitud.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Fixed request item - always shown */}
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              Asignar a:
            </div>
            <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
              <div className="font-medium text-green-900">
                {requestItemDescription}
              </div>
              <div className="text-sm text-green-700 mt-1">
                Item de Solicitud de Compra
              </div>
            </div>
          </div>

          {/* Quote item selector - unified for all cases */}
          <div className="space-y-2">
            <div className="text-sm font-medium text-muted-foreground">
              Seleccionar producto de {supplierName}:
            </div>
            <QuoteItemSelector
              requestItemId={requestItemId}
              allSupplierQuoteItems={allSupplierQuoteItems}
              currentQuoteItemId={currentQuoteItemId}
              onAssign={handleMatchUpdate}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
